// style
import "../scss/index.scss";
{
    // menu
    const btn = document.getElementById("js-menu-toggle");
    const btnClose = document.getElementById("js-menu-close");
    const toggleMenu = (open) => {
        document.body.classList.toggle("menu-open", open);
    };
    const eventType = "ontouchstart" in window ? "touchstart" : "click";
    btn?.addEventListener(eventType, () => toggleMenu(!document.body.classList.contains("menu-open")));
    btnClose?.addEventListener(eventType, () => toggleMenu(false));
}
